import { InternalAxiosRequestConfig } from "axios";
import { appSession } from "../../shared/lib/storage";

export function addAuthHeader(config: InternalAxiosRequestConfig<unknown>) {
  const user = appSession.getItem();

  if (!user) {
    return config;
  }

  config.headers.Authorization = "Bearer " + user.access_token;

  return config;
}
